module.exports = __webpack_public_path__ + "static/GalaxieCopernicus-Semibold-220b6bfd2e27daaf42997a54b5bd6fae.woff";